import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateServer } from "../../../actions/actionServer";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ServerForm from "../AgentForm/AgentForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Agents",path:"/agents",isActive: false},
    {name: "UpdateAgent",path:"/updateagent",isActive: true},
];

class UpdateAgent extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Agent</strong>
                                </CardHeader>
                                <ServerForm
                                    updateServer={this.props.updateServer}
                                    serverId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateAgent.propTypes = {
    updateServer: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    servers: state.servers.servers || []
}), 
dispatch => ({
    updateAgent: () => dispatch(updateAgent())
}))(UpdateAgent);